//import { useState, useEffect } from 'react';

//import { firestoreMethods } from '../firebase/firestoreMethods';
//import { utilMethods } from '../utils/utilMethods';

import { Link } from "react-router-dom";


function TestLogin() {

  return (
    <>
      <div className='outer-box'>
        <div className='title'>
          Test Login
        </div>
        <div className='form-button-group'>
          <Link 
            to="/test/address" 
            className='form-button primary'
          >address
          </Link> 
          <Link 
            to="/test" 
            className='form-button primary'
          >home
          </Link> 
        </div>
      </div>
    </>
  );
}

export default TestLogin;
